"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getTimeSpanText;
function getTimeSpanText(eventOn) {
    eventOn = eventOn + "+00:00";
    eventOn = new Date(eventOn);
    var now = new Date();
    var timeSpanText = null;
    var timeSpan = secondsBetween(eventOn, now);
    if (timeSpan < 60) {
        timeSpanText = timeSpan + " s";
    } else {
        timeSpan = minutesBetween(eventOn, now);
        if (timeSpan < 60) {
            timeSpanText = timeSpan + " m";
        } else {
            timeSpan = hoursBetween(eventOn, now);
            if (timeSpan < 24) {
                timeSpanText = timeSpan + " h";
            } else {
                timeSpan = daysBetween(eventOn, now);

                timeSpanText = timeSpan + " d";
            }
        }
    }

    return timeSpanText;
}

function secondsBetween(start, end) {
    var secondsBetween = (end.getTime() - start.getTime()) / 1000;
    return Math.abs(Math.round(secondsBetween));
}

function minutesBetween(start, end) {
    var minutesBetween = (end.getTime() - start.getTime()) / 1000;
    minutesBetween /= 60;
    return Math.abs(Math.round(minutesBetween));
}

function hoursBetween(start, end) {
    var hoursBetween = (end.getTime() - start.getTime()) / 1000;
    hoursBetween /= 60 * 60;
    return Math.abs(Math.round(hoursBetween));
}

function daysBetween(start, end) {
    var daysBetween = (end.getTime() - start.getTime()) / 1000;
    daysBetween /= 24 * 60 * 60;
    return Math.abs(Math.round(daysBetween));
}